import { z } from "zod";

// ---------------------------------------------------------------------------
// Business vertical (GRA-83)
//
// What kind of organisation the business is. Drives terminology (web app,
// coach prompt, insight texts), the coach preset, which KPI model applies and
// whether CRM-specific UI is shown. Absent means "sales", the original ICP.
// ---------------------------------------------------------------------------

export const BUSINESS_VERTICALS = ["sales", "dvh"] as const;
export type BusinessVertical = (typeof BUSINESS_VERTICALS)[number];
export const BusinessVerticalSchema = z.enum(BUSINESS_VERTICALS);

export const DEFAULT_BUSINESS_VERTICAL: BusinessVertical = "sales";

/** The business's vertical; anything missing or unknown reads as "sales". */
export function getBusinessVertical(
  business: { vertical?: unknown } | null | undefined,
): BusinessVertical {
  const raw = business?.vertical;
  return raw === "dvh" ? "dvh" : DEFAULT_BUSINESS_VERTICAL;
}

/** Grocery retail (dagligvaruhandel): stores, departments, report uploads. */
export function isDvhBusiness(
  business: { vertical?: unknown } | null | undefined,
): boolean {
  return getBusinessVertical(business) === "dvh";
}

/** Coach preset that a vertical uses when the business hasn't chosen one. */
export const DEFAULT_PRESET_FOR_VERTICAL: Record<BusinessVertical, string> = {
  sales: "sales",
  dvh: "dvh",
};

export const SetBusinessVerticalInput = z.object({
  businessId: z.string().min(1),
  vertical: BusinessVerticalSchema,
});
export type SetBusinessVerticalInput = z.infer<typeof SetBusinessVerticalInput>;
